import { render, staticRenderFns } from "./StockReport.vue?vue&type=template&id=6b89189c&"
import script from "./StockReport.vue?vue&type=script&lang=js&"
export * from "./StockReport.vue?vue&type=script&lang=js&"
import style0 from "./StockReport.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports